import React from "react"

import { Vertical, SpacerMiddle, SpacerBottom, ButtonsContainer } from "./styles"

const TextAndMediaVertical = ({
  heading,
  body,
  buttonElement,
  secondaryButtonElement,
  mediaSlotA,
  mediaSlotB,
  mediaSlotC,
  dataId,
  ...props
}) => (
  <Vertical {...props} data-exp-id={dataId}>
    {mediaSlotA}
    {heading && <h3>{heading}</h3>}
    {mediaSlotB && <SpacerMiddle />}
    {mediaSlotB}
    {mediaSlotB && <SpacerMiddle />}
    <div dangerouslySetInnerHTML={{ __html: body }} />
    {(mediaSlotC || buttonElement) && <SpacerBottom />}
    {mediaSlotC}
    {mediaSlotC && <SpacerBottom />}
    <ButtonsContainer>
      {buttonElement}
      {secondaryButtonElement}
    </ButtonsContainer>
  </Vertical>
)

export default TextAndMediaVertical
